import {
  GET_SERIES_ESCOLA,
  GET_SERIES_ESCOLA_SUCCESS,
  ADD_SERIES_ESCOLA,
  ADD_SERIES_ESCOLA_SUCCESS,
  UPDATE_SERIES_ESCOLA,
  UPDATE_SERIES_ESCOLA_SUCCESS,
  DELETE_SERIES_ESCOLA,
  DELETE_SERIES_ESCOLA_SUCCESS,
  LISTA_CURSOS_POR_ESCOLA_SERIES_ESCOLA,
  LISTA_CURSOS_POR_ESCOLA_SERIES_ESCOLA_SUCESSO,
  LISTA_SERIES_POR_CURSO_SERIES_ESCOLA,
  LISTA_SERIES_POR_CURSO_SERIES_ESCOLA_SUCESSO,
  LISTA_ANOS_LETIVOS_POR_CURSO_SERIES_ESCOLA,
  LISTA_ANOS_LETIVOS_POR_CURSO_SERIES_ESCOLA_SUCESSO,
  BUSCA_SERIES_ESCOLA_EDICAO,
  BUSCA_SERIES_ESCOLA_EDICAO_SUCESSO,
  NOVO_SERIES_ESCOLA,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  ON_SHOW_SUCCESS_MESSAGE,
  CANCELA_EDICAO,
  GET_COMPONENTES_SERIE_PADRAO,
  GET_COMPONENTES_SERIE_PADRAO_SUCESSO,
  APLICA_FILTRO_SERIE_ESCOLA
} from '../constants/ActionTypes';

export const onChangeFilterSerieEscola = (e) => ({
  type: APLICA_FILTRO_SERIE_ESCOLA,
  payload: e.target.value
});

export const getComponentesSeriePadrao = (serieId) => {
  return {
    type: GET_COMPONENTES_SERIE_PADRAO,
    payload: { serieId }
  };
};

export const getComponentesSeriePadraoSuccess = (data) => {
  return {
    type: GET_COMPONENTES_SERIE_PADRAO_SUCESSO,
    payload: data
  };
};


export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE
  };
};

export const cancelaEdicao = () => {
  return {
    type: CANCELA_EDICAO
  };
};

export const showMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const showSuccessMessage = (message) => {
  return {
    type: ON_SHOW_SUCCESS_MESSAGE,
    payload: message
  };
};

export const getSeriesEscola = (filter) => {
  return {
    type: GET_SERIES_ESCOLA,
    payload: filter
  };
};

export const getSeriesEscolaSuccess = (data) => {
  return {
    type: GET_SERIES_ESCOLA_SUCCESS,
    payload: data
  };
};

export const addSeriesEscola = (data) => {
  return {
    type: ADD_SERIES_ESCOLA,
    payload: data
  };
};

export const addSeriesEscolaSuccess = (data) => {
  return {
    type: ADD_SERIES_ESCOLA_SUCCESS,
    payload: data
  };
};

export const updateSeriesEscola = (data) => {
  return {
    type: UPDATE_SERIES_ESCOLA,
    payload: data
  };
};

export const updateSeriesEscolaSuccess = (data) => {
  return {
    type: UPDATE_SERIES_ESCOLA_SUCCESS,
    payload: data
  };
};

export const deleteSeriesEscola = (id) => {
  return {
    type: DELETE_SERIES_ESCOLA,
    payload: id
  };
};

export const deleteSeriesEscolaSuccess = (id) => {
  return {
    type: DELETE_SERIES_ESCOLA_SUCCESS,
    payload: id
  };
};

export const listaCursosPorEscolaSeriesEscola = (escolaId) => {
  return {
    type: LISTA_CURSOS_POR_ESCOLA_SERIES_ESCOLA,
    payload: { escolaId }
  };
};

export const listaCursosPorEscolaSeriesEscolaSuccess = (data) => {
  return {
    type: LISTA_CURSOS_POR_ESCOLA_SERIES_ESCOLA_SUCESSO,
    payload: data
  };
};

export const listaSeriesPorCursoSeriesEscola = (cursoId) => {
  return {
    type: LISTA_SERIES_POR_CURSO_SERIES_ESCOLA,
    payload: { cursoId }
  };
};

export const listaSeriesPorCursoSeriesEscolaSuccess = (data) => {
  return {
    type: LISTA_SERIES_POR_CURSO_SERIES_ESCOLA_SUCESSO,
    payload: data
  };
};

export const listaAnosLetivosPorCursoSeriesEscola = (cursoId) => {
  return {
    type: LISTA_ANOS_LETIVOS_POR_CURSO_SERIES_ESCOLA,
    payload: { cursoId }
  };
};

export const listaAnosLetivosPorCursoSeriesEscolaSuccess = (data) => {
  return {
    type: LISTA_ANOS_LETIVOS_POR_CURSO_SERIES_ESCOLA_SUCESSO,
    payload: data
  };
};

export const buscaSeriesEscolaEdicao = (id) => {
  return {
    type: BUSCA_SERIES_ESCOLA_EDICAO,
    payload: id
  };
};

export const buscaSeriesEscolaEdicaoSuccess = (data) => {
  return {
    type: BUSCA_SERIES_ESCOLA_EDICAO_SUCESSO,
    payload: data
  };
};

export const novoSeriesEscola = () => {
  return {
    type: NOVO_SERIES_ESCOLA
  };
};

export const showLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};
